import { defineMessages } from 'react-intl';

export default defineMessages({
  headerTitle: {
    id: 'app.components.Reschedule.headerTitle',
    defaultMessage: 'Reportar um problema',
  },
  title: {
    id: 'app.components.Reschedule.title',
    defaultMessage: 'Reagendar sessão de fotos',
  },
  subtitle: {
    id: 'app.components.Reschedule.subtitle',
    defaultMessage: 'Esse reagendamento pode ser direcionado para você ou para outro fotógrafo.',
  },
  quarantineSubtitle: {
    id: 'app.components.Reschedule.quarantineSubtitle',
    defaultMessage: 'Por prevenção ao COVID-19, o proprietário deverá enviar as fotos do imóvel '
    + 'e garantir que ele seja alugado com segurança.',
  },
  fixedSessionLabel: {
    id: 'app.components.Reschedule.fixedSessionLabel',
    defaultMessage: 'Agendar um horário específico',
  },
  flexibleSessionLabel: {
    id: 'app.components.Reschedule.flexibleSessionLabel',
    defaultMessage: 'Agendar um horário livre',
  },
  ownerPhotosSessionLabel: {
    id: 'app.components.Reschedule.ownerPhotosSessionLabel',
    defaultMessage: 'Agendar envio de fotos pelo proprietário',
  },
  continueButtonLabel: {
    id: 'app.components.Reschedule.continueButtonLabel',
    defaultMessage: 'Continuar',
  },
  backButtonLabel: {
    id: 'app.components.Reschedule.backButtonLabel',
    defaultMessage: 'Voltar',
  },
  rescheduleErrorMessage: {
    id: 'app.components.Reschedule.rescheduleErrorMessage',
    defaultMessage: 'Não foi possivel reagendar sua sessão',
  },
  schedulesDatesTitle: {
    id: 'app.components.Reschedule.schedulesDatesTitle',
    defaultMessage: 'Escolha um dia e horário para reagendamento',
  },
  dateFieldLabel: {
    id: 'app.components.Reschedule.dateFieldLabel',
    defaultMessage: 'Qual o melhor dia?',
  },
  timeFieldLabel: {
    id: 'app.components.Reschedule.timeFieldLabel',
    defaultMessage: 'Em qual horário?',
  },
  timeFieldHelperText: {
    id: 'app.components.Reschedule.timeFieldHelperText',
    defaultMessage: 'Duração média de 30 minutos.',
  },
  scheduleButtonLabel: {
    id: 'app.components.Reschedule.scheduleButtonLabel',
    defaultMessage: 'Agendar',
  },
  keepSessionLabel: {
    id: 'app.components.Reschedule.keepSessionLabel',
    defaultMessage: 'Manter a sessão comigo',
  },
  lastRescheduleWarning: {
    id: 'app.components.Reschedule.lastRescheduleWarning',
    defaultMessage: 'Atenção, essa sessão já foi reagendada {count, plural, one {# vez} other {# vezes}}. '
      + 'Ao optar por reagendar novamente, ela será encaminhada para o próximo fotógrafo disponível.',
  },
  lastPhotographerUnavailableErrorMessage: {
    id: 'app.components.Reschedule.lastPhotographerUnavailableErrorMessage',
    defaultMessage: 'Esse horário não está mais disponível para você. Escolha outro.',
  },
  schedulesDatesErrorTitle: {
    id: 'app.components.Reschedule.schedulesDatesErrorTitle',
    defaultMessage: 'Não foi possível carregar os horários',
  },
  schedulesDatesEmptyTitle: {
    id: 'app.components.Reschedule.schedulesDatesEmptyTitle',
    defaultMessage: 'Nenhum horário disponível',
  },
  schedulesDatesEmptySubtitle: {
    id: 'app.components.Reschedule.schedulesDatesEmptySubtitle',
    defaultMessage: 'Não há horários disponíveis para você nos próximos dias. '
    + 'Tente um horário livre ou fale com o suporte.',
  },
});
